module.exports = __webpack_public_path__ + "static/logo-6e5049428bc5ca8735c69541c8cf1c19.png";